import React from "react";
import "../../styles/Home-page-component/verticals.css";

const HealthcareIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="9" y="3" width="6" height="18" rx="2" fill="#189CF5"/>
    <rect x="3" y="9" width="18" height="6" rx="2" fill="#189CF5"/>
  </svg>
);
const LogisticsIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <circle cx="6" cy="6" r="2" fill="#189CF5"/>
    <circle cx="18" cy="18" r="2" fill="#189CF5"/>
    <path d="M8 6H14C17 6 18 8 18 10V16" stroke="#189CF5" strokeWidth="2"/>
  </svg>
);
const RetailIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="4" y="6" width="16" height="12" rx="2" stroke="#189CF5" strokeWidth="2"/>
    <path d="M4 10H20" stroke="#189CF5" strokeWidth="2"/>
  </svg>
);
const FinanceIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M4 16L10 10L14 14L20 6" stroke="#189CF5" strokeWidth="2"/>
    <circle cx="20" cy="6" r="2" fill="#189CF5"/>
  </svg>
);
const ManufacturingIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="3" fill="#189CF5"/>
    <path d="M12 2V5M12 19V22M2 12H5M19 12H22M4.5 4.5L6.5 6.5M17.5 17.5L19.5 19.5M4.5 19.5L6.5 17.5M17.5 6.5L19.5 4.5"
      stroke="#189CF5" strokeWidth="1.5"/>
  </svg>
);
const EducationIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M4 6C4 5 5 4 6 4H18C19 4 20 5 20 6V18C20 19 19 20 18 20H6C5 20 4 19 4 18V6Z"
      stroke="#189CF5" strokeWidth="2"/>
    <path d="M12 4V20" stroke="#189CF5" strokeWidth="1.5"/>
  </svg>
);

const VerticalsSection = () => {
  return (
    <section className="verticals-section">

      <div className="container">

        <h2 className="section-title">
          Industries We Serve
        </h2>

        <div className="verticals-grid">

          <div className="vertical-card">
            <div className="vertical-icon"><HealthcareIcon /></div>
            <h3>Healthcare</h3>
            <p>AI-powered diagnostics, patient analytics, and automation systems</p>
          </div>

          <div className="vertical-card">
            <div className="vertical-icon"><LogisticsIcon /></div>
            <h3>Logistics</h3>
            <p>Route optimization, demand forecasting, and supply chain intelligence</p>
          </div>

          <div className="vertical-card">
            <div className="vertical-icon"><RetailIcon /></div>
            <h3>Retail</h3>
            <p>Inventory intelligence, recommendation engines, and demand prediction</p>
          </div>

          <div className="vertical-card">
            <div className="vertical-icon"><FinanceIcon /></div>
            <h3>Finance</h3>
            <p>Fraud detection, risk modeling, and real-time financial analytics</p>
          </div>

          <div className="vertical-card">
            <div className="vertical-icon"><ManufacturingIcon /></div>
            <h3>Manufacturing</h3>
            <p>Predictive maintenance, IoT monitoring, and process automation</p>
          </div>

          <div className="vertical-card">
            <div className="vertical-icon"><EducationIcon /></div>
            <h3>Education</h3>
            <p>Adaptive learning platforms and AI-driven content personalization</p>
          </div>

        </div>

      </div>

    </section>
  );
};

export default VerticalsSection;